export default __webpack_public_path__ + "static/media/businessA.43f4f052.jpg";